module.exports = __webpack_public_path__ + "img/crypto-buy.a756d058.png";